import { ReactNode } from 'react';
import Link from 'next/link';
import { BaseAuthCard } from '../BaseAuthCard';

interface AuthPageLayoutProps {
  title: string;
  description: string;
  children: ReactNode;
  footerContent?: ReactNode;
  className?: string;
}

interface AuthLinkProps {
  href: string;
  text: string;
  linkText: string;
}

function AuthLink({ href, text, linkText }: AuthLinkProps) {
  return (
    <p className="text-sm text-muted-foreground">
      {text}{' '}
      <Link href={href} className="font-medium text-primary hover:underline">
        {linkText}
      </Link>
    </p>
  );
}

export function AuthPageLayout({
  title,
  description,
  children,
  footerContent,
  className
}: AuthPageLayoutProps) {
  return (
    <BaseAuthCard 
      title={title}
      description={description}
      className={className}
    >
      {children}
      {footerContent && (
        <div className="mt-6 text-center">
          {footerContent}
        </div>
      )}
    </BaseAuthCard>
  );
}

// Pre-built footer components for common use cases
export function LoginFooter() {
  return (
    <div className="space-y-3 text-center sm:space-y-4">
      <Link
        href="/forgot-password"
        className="text-sm text-primary hover:text-primary/80 hover:underline transition-colors block"
      >
        Forgot your password?
      </Link>
      
      <div className="pt-3 border-t border-border sm:pt-4">
        <AuthLink 
          href="/signup" 
          text="Don't have an account?" 
          linkText="Sign up" 
        />
      </div>
      
      <div className="pt-2">
        <p className="text-xs text-muted-foreground mb-2 sm:text-sm">
          Courtly is a Sports Booking System for effortlessly booking spaces in Tennis, Padel, Pickleball, Badminton courts or Foot5, Football, Basketball, Volleyball grounds.
        </p>
        <p className="text-xs text-muted-foreground opacity-75">
          Streamline your sports facility management with our comprehensive platform.
        </p>
      </div>
    </div>
  );
}

export function SignupFooter() {
  return (
    <AuthLink 
      href="/login" 
      text="Already have an account?" 
      linkText="Log In" 
    />
  );
} 
